import {Component, Input, OnChanges, OnInit, inject} from '@angular/core';
import {DocumentService} from "../../services/document.service";
import {FileStorageResource} from '../../types/settings-types/fileStorageResource';
import {MediaUrlPipe} from '../../pipes/media-url.pipe';
import {NgSrcImageErrorDirective} from '../../directives/ng-src-image-error.directive';
import {VideoSourceErrorDirective} from '../../directives/video-source-error.directive';
import {VideoSrcDirective} from '../../directives/video-src.directive';

@Component({
    selector: 'app-image-preview',
    imports: [
        MediaUrlPipe,
        NgSrcImageErrorDirective,
        VideoSourceErrorDirective,
        VideoSrcDirective
    ],
    templateUrl: './image-preview.component.html',
    styleUrl: './image-preview.component.scss'
})
export class ImagePreviewComponent implements OnInit, OnChanges {
  private documentService: DocumentService = inject(DocumentService);

  @Input() public images: FileStorageResource[] = [];
  @Input() public videos: FileStorageResource[] = [];
  @Input() public hideReactions: boolean = true;

  public isFirstTall: boolean = false;
  public isPortrait: boolean = false;
  public isLargeEnough: boolean = false;
  public media: FileStorageResource[] = [];
  public autoplay: boolean = false;

  public ngOnInit(): void {
    this.prepare();
  }

  public ngOnChanges(): void {
    this.prepare();
  }

  public showGallery(document: FileStorageResource): void {
    this.documentService.showGallery(this.media, document, this.hideReactions);
  }

  public mediaSource(media: FileStorageResource): string | null {
    return media.preview || media.path || null;
  }

  public safeMediaDimension(value: number | null | undefined, fallback: number): number {
    return Number.isFinite(value) && Number(value) > 0 ? Number(value) : fallback;
  }

  private prepare(): void {
    this.media = this.documentService.mergeDocuments(this.videos, this.images);
    this.isFirstTall = false;
    this.isPortrait = false;
    this.isLargeEnough = false;
    this.autoplay = false;

    if (this.media?.[0]) {
      const firstMedia = this.media[0];
      const height = Number(firstMedia.height);
      const width = Number(firstMedia.width);
      this.isPortrait = height > width;
      this.isLargeEnough = height > 500;
      this.isFirstTall = !!(firstMedia.width && firstMedia.height && Number(firstMedia.height) > Number(firstMedia.width));
      this.autoplay = firstMedia.type === 'video' && (firstMedia.size! / 1024 / 1024) < 40;
    }
  }

}
